import extractErrors from "@/helpers/extractErrors";
import { positiveIntOrNull } from "@/loanDays";

export function reportSaveError(store, error, type = "form") {
  const status = error && error.response && error.response.status;
  let title = "Erreur de sauvegarde";
  let content = "L'enregistrement a échoué.";
  let variant = "danger";

  if (status === 403) {
    title = "Permissions insuffisantes";
    content = "Vous n'avez pas les permissions nécessaires pour effectuer cette action.";
    variant = "warning";
  } else if (status === 422) {
    const messages = extractErrors(error.response.data);
    if (messages.length) {
      content = messages.join(", ");
    }
  } else if (status === 400) {
    title = "Mauvaise requête";
    content = "Erreur dans la requête.";
    variant = "warning";
  } else if (status === 401) {
    title = "Erreur d'authentification";
    content = "Mot de passe ou courriel invalide.";
    variant = "warning";
  } else if (status === 404) {
    title = "Page introuvable";
    content = "La page que vous avez demandée est introuvable.";
    variant = "warning";
  } else if (status === 500) {
    title = "Erreur fatale";
    content = "Une erreur système s'est produite.";
  }

  store.commit("addNotification", {
    content,
    title,
    variant,
    type,
  });
}

export function saveOwnerSettings(http, owner) {
  if (
    !owner ||
    !owner.id ||
    typeof owner.allows_declared_expenses !== "boolean" ||
    typeof owner.allows_general_interest_trips !== "boolean"
  ) {
    return Promise.resolve();
  }

  return http.put(`/owners/${owner.id}`, {
    allows_declared_expenses: owner.allows_declared_expenses,
    allows_general_interest_trips: owner.allows_general_interest_trips,
    max_loan_days: positiveIntOrNull(owner.max_loan_days) || 3,
  });
}
